module.exports = __webpack_public_path__ + "img/30.b18b8e23.png";